module.exports = __webpack_public_path__ + "static/media/generic-lady.68c7bc6b.png";